import { render } from "./box-list.vue?vue&type=template&id=b407b828&scoped=true"
import script from "./box-list.vue?vue&type=script&lang=js"
export * from "./box-list.vue?vue&type=script&lang=js"

import "./box-list.vue?vue&type=style&index=0&id=b407b828&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b407b828"]])

export default __exports__